import { render } from "./ProfileItem.vue?vue&type=template&id=d67417a4&scoped=true&ts=true"
import script from "./ProfileItem.vue?vue&type=script&lang=ts"
export * from "./ProfileItem.vue?vue&type=script&lang=ts"

import "./ProfileItem.vue?vue&type=style&index=0&id=d67417a4&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d67417a4"]])

export default __exports__